var map = {
	"./btn-email.png": "f864",
	"./btn-ota-no.png": "6525",
	"./btn-others.png": "7976",
	"./btn-phone.png": "88ec",
	"./btn-pre-reservation-no.png": "97a4",
	"./btn-reservation-no.png": "394d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c12b";